import { IconHome } from '@tabler/icons';

// constant
const icons = { IconHome };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const defaultValidating = {
  id: 'defaultValidating',
  title: 'Completar registro',
  type: 'group',
  children: [
    {
      id: 'defaultValidating',
      title: 'Inicio',
      type: 'item',
      url: '/upload-format-file-validating',
      icon: icons.IconHome,
      breadcrumbs: false
    }
  ]
};

export default defaultValidating;
